// extracted by mini-css-extract-plugin
export var calendar = "TargetPlatformPicker-module__calendar___56gLj";
export var calendarContainer = "TargetPlatformPicker-module__calendarContainer___5EYm8";
export var flex = "TargetPlatformPicker-module__flex___+siHf";
export var option = "TargetPlatformPicker-module__option___XVTs9";
export var optionTitle = "TargetPlatformPicker-module__optionTitle___xVvRT";